const errorsCodes = {
    REWARDS_PROFILE_ALREADY_EXISTS: {
        title: 'Looks like this email address is already associated with a jcp.com account.',
        content: 'Simply sign in and choose “Access My Rewards”. Need help? Call 1-800-322-1189.',
        type: 'error',
    },
    VICTIM: {
        title: "Our bad! We're unable to verify your account.",
        content: 'Please call customer care at 1-800-322-1189.',
        messageState: 3,
        redirect: true,
    },
    LOYALTY_EMAIL_IS_MERGED_ACCOUNT: {
        title: "Our bad! We're unable to verify your account.",
        content: 'Please call customer care at 1-800-322-1189.',
        messageState: 3,
        redirect: true,
    },
    LOYALTY_EMAIL_ADDRESS_DOES_NOT_MATCH: {
        title: 'There is a problem with your rewards account.',
        content: 'Please call customer care at 1-800-322-1189.',
        messageState: 8,
        redirect: true,
        type: 'error',
    },
    LOYALTY_EMAIL_ADDRESS_ALREADY_EXISTS: {
        title: 'There is a problem with your rewards account.',
        content: 'Please call customer care at 1-800-322-1189.',
        type: 'error',
    },
    LOYALTY_SERVICE_DOWN: {
        title: 'Well, this is embarrassing',
        content: 'Please call customer care at 1-800-322-1189.',
        type: 'error',
    },
    ACCOUNT_WITH_THE_EMAIL_ALREADY_HAS_REWARDS: {
        messageState: 8,
        redirect: true,
    },
    OPTED_OUT: {
        title: 'There is a problem with your rewards account.',
        content: 'Please call customer care at 1-800-322-1189.',
        type: 'error',
    },
    REWARDS_EMAIL_ALREADY_IN_USE: {
        title: 'Looks like this email address is already associated with a jcp.com account.',
        content: 'Simply sign in and choose “Access My Rewards”. Need help? Call 1-800-322-1189.',
        type: 'error',
    },
    SRV_ACCOUNT_EMAILALREADYINUSE: {
        title: 'The email address you entered is already associated with jcp.com account.',
        content: 'Simply sign in and choose “Access My Rewards”. Need help? Call 1-800-322-1189.',
        type: 'error',
    },
    REWARDS_PROFILE_NOT_FOUND: {
        notifyState: 2,
        title: 'Looks like this email address is already associated with a jcp.com account.',
        content: 'Simply sign in and choose “Access My Rewards”. Need help? Call 1-800-322-1189.',
        type: 'error',
    },
    LOYALTY_PROFILE_NOT_FOUND: {
        notifyState: 2,
        title: 'Looks like this email address is already associated with a jcp.com account.',
        content: 'Simply sign in and choose “Access My Rewards”. Need help? Call 1-800-322-1189.',
        type: 'error',
    },
    AUTHORIZATION_FAILED: {
        title: "Our bad! We're unable to verify your account.",
        content: 'Please call customer care at 1-800-322-1189.',
        type: 'error',
    },
    LIL_SERVICE_DOWN: {
        title:
            "Well, this is embarrassing. Due to a temporary technical issue, we're not able to retrieve your Rewards information right now. ",
        content: 'Please try again later.',
        type: 'error',
    },
    GENERIC_SERVICE_ERROR: {
        title:
            "Well, this is embarrassing. Due to a temporary technical issue, we're not able to retrieve your Rewards information right now. ",
        content: 'Please try again later.',
        type: 'error',
    },
    LOYALTY_PROFILE_CLOSED_GET_RWD: {
        title: "Our bad! We're unable to verify your account.",
        content: 'Please call customer care at 1-800-322-1189.',
        messageState: 3,
        redirect: true,
    },
    LOYALTY_PROFILE_CLOSED_SEARCH_RWD: {
        title: "Our bad! We're unable to verify your account.",
        content: 'Please call customer care at 1-800-322-1189.',
        messageState: 3,
        redirect: true,
    },
    LOYALTY_EMAIL_IS_NOT_SAME_AS_DP_EMAIL: {
        title: "Our bad! We're unable to verify your account.",
        content: 'Please call customer care at 1-800-322-1189.',
        type: 'error',
    },
    SVC_ERR_FIRSTNAME_INVALIDLENGTH: {
        title: 'Invalid Firstname',
        content: 'First name should contain not more than 17 characters.',
        type: 'error',
    },
    SRV_CUSTOMER_FIRSTNAME_INVALID: {
        title: 'Invalid Firstname',
        content: 'Please provide a valid first name.',
        type: 'error',
    },
    SVC_USR_ERR_LASTNAME_INVALIDLENGTH: {
        title: 'Invalid Lastname',
        content: 'Last name should contain not more than 24 characters.',
        type: 'error',
    },
    SVC_USR_ERR_CREDITCARDLENGTH_INVALID: {
        title: 'Enter valid card number',
        content: '',
        type: 'error',
    },
    SRV_ACCOUNT_EMAILALREADY_HAS_REWARDS: {
        title: 'Account Already exists',
        messageState: 4,
        redirect: true,
        type: 'error',
    },
    SRV_CUSTOMER_LASTNAME_INVALID: {
        title: 'Invalid Lastname',
        content: 'Please provide a valid last name.',
        type: 'error',
    },
    SRV_PASS_EQL_OLD_PASS: {
        title: 'Invalid Password',
        content: 'Password must differ from previously used',
        type: 'error',
    },
    REDIRECT_DEFAULT: {
        title: 'There is a problem with your rewards account.',
        content: 'Please call customer care at 1-800-322-1189.',
        redirect: true,
    },
    SRV_CUSTOMER_EMAIL_ISNULL: {
        title: 'Invalid email address.',
        content: 'Please enter a valid email address.',
        redirect: false,
    },
    SRV_ACCOUNT_GENERAL_ERROR: {
        title:
            'This account already exists. Please use a different email or <a href="javascript:void(0)">sign in</a>.',
        redirect: false,
        type: 'error',
    },
    SRV_PHONE_EXIST_ERROR: {
        title: 'This account already exists. Please use a different <b>phone number</b>.',
        redirect: false,
        type: 'error',
    },
    SRV_EMAIL_EXIST_ERROR: {
        title: 'This account already exists. Please use a different <b>email</b>.',
        redirect: false,
        type: 'error',
    },
    SRV_EMAIL_AND_PHONE_EXIST_ERROR: {
        title:
            'This account already exists. Please use a different <b>email</b> and <b>phone number</b>.',
        redirect: false,
        type: 'error',
    },
    SRV_SYSTEM_TIMEOUT_ERROR: {
        title: 'We are unable to create your account. Please try again later.',
        redirect: false,
        type: 'error',
    },
    SRV_RESET_PASSWORD_DEFAULT: {
        title:
            'There was a problem updating your account. If the problem persists, call Customer Service at (800) 322-1189.',
        redirect: false,
        type: 'error',
    },
    DEFAULT: {
        title: 'We’re having trouble completing your request. Try again.',
        type: 'error',
    },
    ACCOUNT_CREATE_NOT_ALLOWED: {
        title:
            'There was an error while processing your request. Please try again or contact JCPenney Customer Service at 1-800-322-1189.',
        type: 'error',
    },
    SRV_CHECKOUT_CREATE_ACCOUNT_ERROR_DEFAULT: {
        title: 'We are unable to create your account. Please try again later.',
    },
};

export default errorsCodes;
